export default __webpack_public_path__ + "static/media/2.c3a295aa.png";